import i18n from "i18next";
import Backend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";
import { languages, languageToNewFormat } from "./languages";
import { getWhiteLabel } from "./white-label";

const supportedLocales = new Set(languages.map((lang) => lang.locale));

const fallbackLng = "en_US";

export const getInitialLocale = (oldFormat?: boolean) => {
  const urlParts = window.location.pathname.split("/");
  let locale = urlParts.find((part) =>
    supportedLocales.has(part.toLowerCase()),
  );

  if (!locale) {
    locale = getWhiteLabel().locale || "en-us";
  }

  return oldFormat ? locale : languageToNewFormat(locale);
};

export const setTranslation = async () => {
  // eslint-disable-next-line import/no-named-as-default-member
  i18n
    .use(Backend)
    .use(initReactI18next)
    .init({
      fallbackLng,
      lng: getInitialLocale(),
      debug: false,
      partialBundledLanguages: true,
      react: {
        useSuspense: false,
      },
      backend: {
        loadPath: "/transfer/locales/{{lng}}/{{ns}}.json",
      },
    });

  await i18n.loadNamespaces("ui:country-input");
  // TODO: This is a workaround for the issue with the country input not loading translations correctly.
  // We should use https://react.i18next.com/latest/i18nextprovider to fix this properly.
  window.i18n = i18n;
};
